import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const CommonBtn = styled(Button)`
  border-radius: 14px;
  padding: 10px;
  min-width: 150px;
  font-weight: 600;
  font-size: 14px;
  text-transform: none;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;